module.exports = __webpack_public_path__ + "img/bgs-scene-office1.497c3992.png";